
import { hollyBio, luigiBio, gatsbyBio } from './frodoBios'
import { hollyReviewerReviewHinge, luigiReviewerReviewBumble, gatsbyReviewerReviewTinder } from './frodoReviewerReviews'

export const hollyReviewerProfile = {
  _id: 'hollyReviewerProfileId',
  userId: 'hollyUserId',
  email: 'holly@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-holly-12-sq.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: false,
  isHotty: true,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `NA`,
  openAIAssistantID: `NA`,
  bio: { ...hollyBio },
  profileReviews: [
    // { ...hollyProfileReviewHinge }
  ],
  reviewerReviews: [
    { ...hollyReviewerReviewHinge }
  ],
}

export const luigiReviewerProfile = {
  _id: 'luigiReviewerProfileId',
  userId: 'luigiUserId',
  email: 'luigi@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-luigi-13-sq.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: true,
  isHotty: false,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `Open AI gpt4o mini`,
  openAIAssistantID: `NA`,
  bio: { ...luigiBio },
  profileReviews: [
    // { ...luigiProfileReviewBumble }
  ],
  reviewerReviews: [
    { ...luigiReviewerReviewBumble }
  ],
}

export const gatsbyReviewerProfile = {
  _id: 'gatsbyReviewerProfileId',
  userId: 'gatsbyUserId',
  email: 'gatsby@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-gatsby-12-sq.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: false,
  isHotty: true,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `NA`,
  openAIAssistantID: `NA`,
  bio: { ...gatsbyBio },
  profileReviews: [
    // { ...gatsbyProfileReviewTinder }
  ],
  reviewerReviews: [
    { ...gatsbyReviewerReviewTinder }
  ],
}